import ENV from "config/Env";
import { backendQueryKey } from "hooks/useTypedQuery";
import { UPDATE_TYPE, backendQueryKey as untypedBackendQueryKey } from "utils/keyFactory";

import type { DealerReportThreshold, QUESTION_RESULT_STATUSES } from "models";

const component = "DealerReports";

export type QualityCheckFilters = {
  mechanicId?: number;
  locationId?: number;
  qcOfficerId?: number;
  qcStatus?: QUESTION_RESULT_STATUSES;
  qcChecklistId?: number;
};

type DealerReportParams = {
  index: number;
  dealer_id: number;
  report_id: number;
  date_from?: string;
  date_to?: string;
  is_internal?: boolean | null;
  is_lease_company?: boolean | null;
};

export const DealerReportQueryKeys = {
  dealerReport: ({ index, dealer_id, report_id, date_from, date_to, is_internal, is_lease_company }: DealerReportParams) => [
    untypedBackendQueryKey({
      updateType: UPDATE_TYPE.Static,
      component,
      baseUrl: ENV.reportsBaseURL,
      endpoint: "/dealers/view",
      params: {
        index,
        dealer_id,
        report_id,
        ...(date_from && date_to ? { date_from, date_to } : {}),
        ...(is_internal !== null && is_internal !== undefined ? { is_internal } : {}),
        ...(is_lease_company !== null && is_lease_company !== undefined ? { is_lease_company } : {})
      }
    })
  ],
  emailStats: (dealer_id: number, date_from?: string, date_to?: string) =>
    backendQueryKey<Record<string, number>[]>({
      component,
      baseUrl: ENV.reportsBaseURL,
      endpoint: "/dealers/email/view",
      params: { dealer_id, ...(date_from && date_to && { date_from, date_to }) }
    }),
  listGroups: backendQueryKey<number[]>({ component, baseUrl: ENV.reportsBaseURL, endpoint: "/dealers/groups/list" }),
  listReports: (dealer_id: number, template_group: number) =>
    backendQueryKey<number[]>({
      component,
      baseUrl: ENV.reportsBaseURL,
      endpoint: "/dealers/list",
      params: { dealer_id, template_group }
    }),
  listThresholds: (dealer_id: number) =>
    backendQueryKey<DealerReportThreshold[]>({
      component,
      baseUrl: ENV.reportsBaseURL,
      endpoint: "/dealers/thresholds/list",
      params: { dealer_id }
    })
};
